// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-fit-content[data-v-f8ea0466] {\n  flex: 1 1 auto;\n  margin-bottom: 2rem;\n  padding: 0px 1.25rem;\n}\n.form-group-row[data-v-f8ea0466] {\n  gap: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.form-group-row label[data-v-f8ea0466] {\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n.form-group-row input[data-v-f8ea0466] {\n  max-width: 250px;\n}", ""]);
// Exports
module.exports = exports;
